import React, { useMemo, memo } from 'react';
import { SquareDashed } from 'lucide-react';
import PropTypes from 'prop-types';

import styles from './styles/ServiceLogo.module.css';

const ServiceLogo = ({ logo, name, size = 'medium', className = '' }) => {
    const logoClassName = useMemo(() => {
        return `${styles.logo} ${styles[size]} ${className}`;
    }, [size, className]);

    return logo ? (
        <img
            src={logo}
            alt={name || 'Service logo'}
            className={logoClassName}
        />
    ) : (
        <div className={`${styles.emptyLogo} ${logoClassName}`}>
            <SquareDashed className={styles.icon} />
        </div>
    );
};

ServiceLogo.propTypes = {
    logo: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.oneOfType([
        PropTypes.oneOf(['tiny', 'small', 'medium', 'large', 'xlarge']),
        PropTypes.number,
    ]),
    className: PropTypes.string,
};

export default memo(ServiceLogo);
